import React from "react";
import Vimeo from "@u-wave/react-vimeo";
import CloseIcon from "@mui/icons-material/Close";

const VideoPlayer = ({ selectedVideoId, setSelectedVideoId }) => {
  if (!selectedVideoId) {
    return <div></div>;
  }

  return (
    selectedVideoId && (
      <div className="vimeo-player-wrapper">
        <div className="bg-dark" />
        <div className="close-icon">
          <CloseIcon onClick={() => setSelectedVideoId(null)} />
        </div>
        <Vimeo
          className="width"
          video={selectedVideoId} // Replace with your Vimeo video ID
          autoplay
        />
      </div>
    )
  );
};

export default VideoPlayer;
